import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from "../../config";
import '../../css/adminResumes.css';

const AdminResumes = () => {
  const [resumes, setResumes] = useState([]);

  useEffect(() => {
    fetchResumes();
  }, []);

  const fetchResumes = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/resumes`, {
        withCredentials: true,
      });
      setResumes(res.data);
    } catch (err) {
      console.error(err);
      alert('Error fetching resumes');
    }
  };
return (
  <div className="admin-resume-page">
    <div className="resumes-container">
      <h2 className="resumes-title">Uploaded Resumes</h2>

      {Array.isArray(resumes) && resumes.length > 0 ? (
        resumes.map((resume) => (
          <div key={resume.resume_id} className="resume-card">
            <h3>{resume.firstname} {resume.lastname}</h3>

            <p><strong>Email:</strong> {resume.email_address}</p>
            <p><strong>Phone:</strong> {resume.phone_number}</p>

            <p>
              <strong>Location:</strong> 
              {resume.city}, {resume.state}, {resume.country}, 
              {resume.address1}, {resume.address2}, {resume.zip_code}
            </p>

            <p>
              <strong>Job Applied:</strong> 
              {resume.job_title}, {resume.description}, 
              {resume.location}, {resume.salary}
            </p>

            <h4>Education</h4>
            <p>{resume.highest_qualification} from {resume.institution_name} ({resume.year_of_graduation})</p>

            <h4>Experience</h4>
            <p>{resume.experience_title} at {resume.company_name} ({resume.start_year} - {resume.end_year})</p>

            <p>
              <strong>Resume:</strong>{' '}
              <Link
                to={`/resumes/download/${resume.resume_id}`}
                className="download-link"
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                Download
              </Link>
            </p>

            <hr />
          </div>
        ))
      ) : (
        <p>No resumes found or an error occurred.</p>
      )}
    </div>
  </div>
);

};

export default AdminResumes;
